import React from "react";
import {
  MediumContainer,
  NextBtn,
} from "../../../screens/User/Users/components/IncidentType/incident.style";
import { AiOutlineClose } from "react-icons/ai";

const AllegedAbuseFlag = ({
  setShowAllegedAbuseFlag,
}: {
  setShowAllegedAbuseFlag: (value: boolean) => void;
}) => {
  function handleModalClose() {
    setShowAllegedAbuseFlag(false);
  }
  return (
    <MediumContainer>
      <div className="flex">
        <button
          className="cursor-pointer border-0 bg-transparent"
          onClick={handleModalClose}
          style={{ fontSize: "30px" }}
          onKeyDown={() => {}}
        >
          <AiOutlineClose size={25} />
        </button>
      </div>
      <p className="text-md px-5 py-5 text-center">
        Potential Reportable Incident. Please Notify the Administrator or
        Designee Immediately. Click the button or close this prompt to proceed.
      </p>

      <div className="mb-14 mr-7 mt-5">
        <NextBtn onClick={handleModalClose}>Okay</NextBtn>
      </div>
    </MediumContainer>
  );
};

export default AllegedAbuseFlag;
